import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '虚拟机',
    type: 'PHYS_DEPLOYED_VR',
}
